import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FolderDocumentsRefreshEvent } from 'src/app/models/events/folder-documents-refresh-event';
import { FolderListDeletedEvent } from 'src/app/models/events/folder-list-deleted-event';
import { FolderListExportEvent } from 'src/app/models/events/folder-list-export-event';
import { FolderListRefreshEvent } from 'src/app/models/events/folder-list-refresh-event';
import { FolderListUpdatedEvent } from 'src/app/models/events/folder-list-updated-event';

@Injectable({
    providedIn: 'root',
})
export class FolderListEventsService {
    /**
     * Emis lorsque la liste des dossiers doit être completement rechargées
     */
    public listNeedRefresh = new Subject<FolderListRefreshEvent>();

    /**
     * Emis lorsque des dossiers de la liste doivent être mis à jour
     */
    public foldersUpdated = new Subject<FolderListUpdatedEvent>();

    /**
     *  Emis lorsque les documents d'un dossier ont été mis à jour.
     */
    public folderDocumentsUpdated = new Subject<FolderDocumentsRefreshEvent>();

    /**
     * Emis lorsque des dossiers de la liste doivent être supprimés
     */
    public foldersDeleted = new Subject<FolderListDeletedEvent>();

    /**
     * Emis lorsque les dossiers de la liste doivent être exportés
     */
    public exportRequest = new Subject<FolderListExportEvent>();
}
